// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"9fcf94a7","81":"26998fa4","111":"3c53e09a","128":"eb7c20c0","144":"7f79c6a0","184":"0f5822ca","245":"ae121d49","453":"0ca3281e","478":"87ed0d67","536":"7f0a7b8a","562":"616571b0","593":"3b1462ec","753":"8ba8a5cd","810":"07bb686e","830":"2a9741f1"}[chunkId] + ".chunk.js";
};